import { render, staticRenderFns } from "./OnOrderDetail.vue?vue&type=template&id=69519632"
import script from "./OnOrderDetail.vue?vue&type=script&lang=js"
export * from "./OnOrderDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports